// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"eka-z","tooltip":"fka-z","tooltipContent":"gka-z","orderStatusWrapper":"hka-z"};